export default {
  namespaced: true,
  state () {
    return {
      userRoles: [],
      rolePermissions: []
    }
  },
  getters: {
    backendUserRoles (state) {
      return state.userRoles
    },
    backendRolePermissions (state) {
      return state.rolePermissions
    }
  },
  mutations: {
    setUserRoles (state, payload) {
      state.userRoles = payload
    },
    setRolePermissions (state, payload) {
      state.rolePermissions = payload
    }
  },
  actions: {
    async adjustUserRole (context, payload) {
      if (payload.status === true) {
        await context.rootState.authAxios.put('/UserRoles',
          payload
        ).catch((error) => {
          console.error('Có lỗi xảy ra ', error)
        })
      } else {
        await context.rootState.authAxios.post('/UserRoles',
          payload
        ).catch((error) => {
          console.error('Có lỗi xảy ra ', error)
        })
      }
    },
    async getUserRoleData (context) {
      await context.rootState.authAxios.get('/UserRoles').then((response) => {
        context.commit('setUserRoles', response.data)
      }).catch((error) => {
        console.error('Có lỗi xảy ra ', error)
      })
    },
    async adjustRolePermission (context, payload) {
      if (payload.status === true) {
        await context.rootState.authAxios.put('/RolePermissions',
          payload
        ).catch((error) => {
          console.error('Có lỗi xảy ra ', error)
        })
      } else {
        await context.rootState.authAxios.post('/RolePermissions',
          payload
        ).catch((error) => {
          console.error('Có lỗi xảy ra ', error)
        })
      }
    },
    async getRolePermissionData (context) {
      await context.rootState.authAxios.get('/RolePermissions').then((response) => {
        context.commit('setRolePermissions', response.data)
      }).catch((error) => {
        console.error('Có lỗi xảy ra ', error)
      })
    }
  }
}
